export type OAuthHandoffRecord = {
  id: string;
  provider: string;
  createdAt: number;
};

const STORAGE_KEY = "bhadapms_oauth_handoff";
const EVENT_NAME = "bhadapms:oauth-handoff-started";

export const oauthHandoffStore = {
  start(provider: string): string {
    const id = crypto.randomUUID();
    const record: OAuthHandoffRecord = { id, provider, createdAt: Date.now() };
    
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (e) {
      console.error("[oauth-handoff-store] Failed to save to localStorage", e);
    }
    
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: record }));
    return id;
  },

  get(): OAuthHandoffRecord | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      
      const record = JSON.parse(raw) as Partial<OAuthHandoffRecord>;
      if (!record.id || !record.provider || !record.createdAt) {
        this.clear();
        return null;
      }
      
      // 10 minutes expiration logic
      if (Date.now() - record.createdAt > 10 * 60 * 1000) {
        this.clear();
        return null;
      }
      
      return record as OAuthHandoffRecord;
    } catch (e) {
      console.error("[oauth-handoff-store] Failed to read from localStorage", e);
      this.clear();
      return null;
    }
  },

  clear(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error("[oauth-handoff-store] Failed to clear localStorage", e);
    }
  },

  subscribeStarted(cb: (record: OAuthHandoffRecord) => void): () => void {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<OAuthHandoffRecord>;
      cb(customEvent.detail);
    };
    
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  },
};